import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LicensePlatesDataDto } from '@app/data/dtos/ptrab/license-plates/license-plates.dto';
import {
  mapLicensePlatesData,
  mapLicensePlateToDto
} from '@app/data/mappers/ptrab/license-plates/license-plates.mappers';
import { LicensePlatesRepository } from '@app/domain/repositories/ptrab/license-plates/license-plates.repository.contract';
import { VehicleType } from '@app/entities/enums/ptrab/vehicle-type.enum';
import { IDataResponse } from '@app/entities/interfaces/data/data.interface';
import { LicensePlateRequest, LicensePlates } from '@app/entities/models/ptrab/license-plates/license-plates.model';
import { ENV } from '@environments/environment';
import { SECTION_KEY } from '@services/interceptors/error-sections.interceptor/error-sections.interceptor';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class LicensePlatesRepositoryImpl extends MRepository implements LicensePlatesRepository {
  url = '/ptrab/license-plates';

  constructor() {
    super(`${ENV.API_URL_PTRAB}`);
  }

  getLicensePlates(): Observable<LicensePlates> {
    return this.get<IDataResponse<LicensePlatesDataDto>>(this.url, {
      context: new HttpContext().set(SECTION_KEY, 'license-plates')
    }).pipe(map(mapLicensePlatesData));
  }

  createLicensePlate(licensePlate: LicensePlateRequest, vehicleType: VehicleType): Observable<object> {
    const request = {
      body: mapLicensePlateToDto(licensePlate)
    };

    return this.post(`${this.url}/${vehicleType}`, request);
  }

  updateLicensePlate(
    licensePlate: LicensePlateRequest,
    vehicleType: VehicleType,
    vehicleId: string
  ): Observable<object> {
    const request = {
      body: mapLicensePlateToDto(licensePlate)
    };

    return this.put(`${this.url}/${vehicleType}/${vehicleId}`, request);
  }

  deleteLicensePlate(vehicleType: VehicleType, vehicleId: string): Observable<object> {
    return this.delete(`${this.url}/${vehicleType}/${vehicleId}`);
  }
}
